import { styled } from '$utils/theme'
import { Text } from '$views/components'
import { rem } from 'polished'

interface Props {
  maxWidth: number
}

export const OverflowText = styled(Text)<Props>`
  max-width: ${p => rem(p.maxWidth)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`



// WEBPACK FOOTER //
// ./src/views/components/OverflowText/OverflowText.ts